export const LOAD_QUESTIONS = 'LOAD_QUESTIONS'
export const LOAD_QUESTION = 'LOAD_QUESTION'
export const ADD_QUESTION = 'ADD_QUESTION'